<template>
  <div>
    <table class="table table-sm">
      <tbody>
        <tr>
          <td>TÍTULO</td>
          <td>
            <strong>{{ order.title }}</strong>
          </td>
        </tr>
        <tr>
          <td>TEXTO</td>
          <td>
            <strong>{{ order.text }}</strong>
          </td>
        </tr>
        <tr>
          <td>RESPONSÁVEL</td>
          <td>
            <strong>{{
              professionalClassCouncilValue({
                id: order.user_professional_class_council_id,
                name: order.user_name,
                profile: order.user_profile_name,
                office: order.user_office,
                cpf: order.user_cpf,
                value: order.user_professional_class_council_value,
              })
            }}</strong>
          </td>
        </tr>
        <tr>
          <td>STATUS</td>
          <td>
            <span v-if="order.status == 1" class="c-success">ATIVO</span>
            <span v-else class="c-danger">INATIVO</span>
          </td>
        </tr>
        <tr>
          <td>DATA DO REGISTRO</td>
          <td>
            <strong>{{
              moment(order.created_at).format("DD/MM/YYYY HH:mm:ss")
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import { professionalClassCouncilValue } from "../../../../lib/format";

export default {
  name: "Details",

  props: {
    order: Object,
  },

  created() {},

  methods: {
    moment,
    professionalClassCouncilValue,
  },
};
</script>
